module.exports = __webpack_public_path__ + "static/hero-image-f0f50329673eebea287a64b90d02c0d0.jpg";